import { FileDocumentIcon, VideoFileIcon } from "@flat-ui";
export const fileIcons = {
  pdf: FileDocumentIcon,
  txt: FileDocumentIcon,
  xls: FileDocumentIcon,
  xlsx: FileDocumentIcon,
  mp4: VideoFileIcon,
  default: FileDocumentIcon
};